<template>
  <div class="page-section">
    <h1 class="section-title">
      Spending Categories
    </h1>
    <p class="section-subtitle">
      Here are the categories you spent most on in the last 5 months
    </p>
    <div
      v-if="isDataMissing"
      class="connect-another-subtitle"
    >
      We don't have enough data to display your spending categories.
      <b @click="handleConnectAccountsClick">connect an active <br> account</b>
      to get the full picture
    </div>
    <div
      v-for="(category, index) in monthlyCategoryAverages.slice(0, 7)"
      :key="index"
      class="category-item"
      :class="{ 'disabled': isDataMissing }"
    >
      <span class="category-label">{{ category.categoryLabel }}</span>
      <span class="category-amount">£{{ numberToHumanReadable(Math.round(category.averageSpending)) }}</span>
    </div>
    <button
      class="green-button"
      @click="navigateToEtoro"
    >
      Put your cash to work <span class="arrow-right">→</span>
    </button>
  </div>
</template>

<script setup>
import { numberToHumanReadable } from '../../../../utils/miscUtils';

const props = defineProps({
  monthlyCategoryAverages: {
    type: Array,
    required: true,
    default: () => [],
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['navigateToEtoro', 'connectAccountsClick']);

const navigateToEtoro = () => {
  emit('navigateToEtoro');
};

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.connect-another-subtitle {
  font-size: 14px;
  font-family: CircularStdBook;
  margin-bottom: 30px;
  margin-top: 30px;
  background-color: #FFDC73;
  color: #205441;
  text-align: center;
  padding: 20px;
  border-radius: 16px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.category-item {
  background-color: white;
  border-radius: 20px;
  width: 90%;
  padding: 20px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 16px 46px rgba(22.80, 123.92, 42.57, 0.62);

  &.disabled {
    background-color: #F1F5FA !important;
    box-shadow: 0px 16px 46px rgba(22.80, 123.92, 42.57, 0.1) !important;
    .category-label,
    .category-amount {
      color: #B0B0B0 !important;
    }
  }
}

.category-label {
  font-size: 18px;
  color: #333;
  font-family: CircularStdBook;
}

.category-amount {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.green-button {
  background-color: #205441;
  box-shadow: 0px 4px 21px rgba(149.13, 152.94, 149.88, 0.56);
  border-radius: 12px;
  color: white;
  padding: 17px 0px;
  border: none;
  width: 90%;
  cursor: pointer;
  font-size: 18px;
  font-family: CircularStdBook;
  font-weight: 700;
  margin: 37px auto;
  margin-bottom: 70px;
  display: block;
}

.arrow-right {
  margin-left: 10px;
  font-family: CircularStdBook;
}

.section-title {
  font-size: 48px;
  font-weight: bold;
  font-family: CircularStd;
  line-height: 1;
  margin-top: 30px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  color: white;
}

.section-subtitle {
  font-size: 19px;
  font-family: CircularStdBook;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  color: white;
}
</style>
